import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { Session } from '@services/session';
import { FleetGrowthFeatureFlagService } from '@services/feature-flags/growth';

@Injectable()
export class BillingManagementAccessGuard implements CanActivate {
  constructor(
    private router: Router,
    private session: Session,
    private fleetGrowthFeatureFlagService: FleetGrowthFeatureFlagService,
  ) {}

  public canActivate(): boolean {
    if (this.fleetGrowthFeatureFlagService.isAdminBillingManagementEnabled()) return true;

    this.router.navigate(['/admin']);
    return false;
  }
}
